import { render, staticRenderFns } from "./SettingsAddresses.vue?vue&type=template&id=748c3170&"
import script from "./SettingsAddresses.vue?vue&type=script&lang=js&"
export * from "./SettingsAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports